
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whitepaper/[slug]",
      function () {
        return require("private-next-pages/whitepaper/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whitepaper/[slug]"])
      });
    }
  